import React from 'react';
import User from '../../Icons/User';
import styles from './SignIn.module.scss';

export interface ISignIn {
  children?: React.ReactNode;
  signInUrl?: string;
  ariaLabel?: string;
}

export default function SignIn({ children, signInUrl = '#', ariaLabel }: ISignIn) {
  return (
    <a
      href={signInUrl}
      className={styles.signIn}
      aria-label={ariaLabel}
      referrerPolicy="same-origin"
      rel="noopener"
    >
      <User />
      <span className={styles.text}>{children}</span>
    </a>
  );
}
